import * as stylex from '@stylexjs/stylex';
import { styles } from './styles.ts';
import EventForm from '../../features/create-event-form';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export interface IStepperProps {
  title?: string;
  isCompleted?: boolean;
}

export const NewEvent: FC = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState<number>(0);

  const nextStepHandle = () => {};

  const prevStepHandle = () => {
    const previousStep = currentStep - 1;
    setCurrentStep(previousStep < 0 ? 0 : previousStep);
    if (previousStep < 0) {
      navigate(-1);
    }
  };

  return (
    <div {...stylex.props(styles.base)}>
      <EventForm
        currentStep={currentStep}
        nextStepHandle={nextStepHandle}
        prevStepHandle={prevStepHandle}
        selectedDate={[]}
      />
    </div>
  );
};
